// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"435":"9dd614a0","2589":"32fc1245","6105":"4c9af2c5"}[chunkId] + ".css";
};